<template>
  <div class="">
    伟业
  </div>
</template>

<script>
export default {
  name: ''
}
</script>

<style lang="scss" scoped>

</style>
